export default __webpack_public_path__ + "static/media/character_joy_hands_interview.5d7c4d23.svg";